<template>
  <form enctype="multipart/form-data">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{grade_id ? 'Update' : 'Create'}} Grade</p>
      </header>
      <div class="modal-card-body">
        <!--Loading-->
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <b-field label="Name">
          <b-input
            v-model="grade.name"
            ref="title"
            minlength="3"
            required
            type="text"
            placeholder="Add grade name here"
          ></b-input>
        </b-field>
        <b-field label="Description">
          <b-input
            ref="message"
            minlength="3"
            v-model="grade.description"
            type="textarea"
            placeholder="Add grade description here"
          ></b-input>
        </b-field>

        <b-field grouped>
          <b-field label="Order" expanded>
            <b-numberinput
              ref="order"
              minlength="3"
              expanded
              v-model="grade.order"
              placeholder="Add grade order here"
            ></b-numberinput>
          </b-field>
          <b-field label="Theme Color" expanded>
            <b-input
              expanded
              v-model="grade.theme_color"
              placeholder="Add theme color here"
            ></b-input>
          </b-field>
        </b-field>
        
        <b-field label="Remarks">
          <b-input
            ref="message"
            minlength="3"
            v-model="grade.remarks"
            type="textarea"
            placeholder="Add any remarks"
          ></b-input>
        </b-field>
        <b-field label="Status">
          <b-switch
            ref="status"
            v-model="grade.status"
            type="is-success"
          >{{grade.status ? 'Active' : 'Non-Active'}}</b-switch>
        </b-field>
        <!-- <div class="tags">
          <span
            v-for="(file_obj, edit_file_index) in editfiles"
            :key="`EDIT_FILE_${edit_file_index}`"
          >
            <span style="margin: 0 5px;" class="tag is-primary" v-if="!file_obj.is_deleted">
              {{$common.fileBasename(file_obj.name)}}
              <button
                class="delete is-small"
                type="button"
                @click="deleteExistingFile(edit_file_index)"
              ></button>
            </span>
          </span>
        </div> -->
        <!-- <b-field class="file">
          <b-upload v-model="announcementfiles" multiple>
            <a class="button is-dark">
              <b-icon icon="upload"></b-icon>
              <span>Add Files</span>
            </a>
          </b-upload>
          <span
            class="file-name"
            v-for="(file, file_index) in announcementfiles"
            :key="file_index"
          >{{file.name}}</span>
        </b-field> -->
        <button
          type="button"
          @click.prevent="proceed()"
          class="button is-success btn-center"
        >{{grade_id ? 'Update' : 'Create'}}</button>
      </div>
    </div>
  </form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "set-grade",
  data() {
    return {
      // announcementfiles: null,
      isLoading: false,
      grade : {
        name: "",
        description: "",
        order : null,
        remarks : "",
        status : true,
        theme_color : null
        // editfiles: [],
      }
    };
  },
  props: {
    grade_id: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["getTeacherToken", "fetchCurrentGrade"]),
  },
  methods: {
    ...mapActions([
      "createGrade",
      "updateGrade",
      "loadGradeDetails",
    ]),
    deleteExistingFile(index) {
      this.editfiles[index].is_deleted = true;
    },
    proceed() {
      let is_validate = this.$refs.title.checkHtml5Validity() && this.$refs.message.checkHtml5Validity();
      if (is_validate) {
        this.isLoading = true;
        if (this.grade_id) {
          //For editing a grade
          this.updateGrade({
            grade_id: this.grade_id,
            grade: this.grade,
            token: this.getTeacherToken,
          })
          .then(() => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: "Grade updated successfully",
              type: "is-success",
            });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$emit("over");
            console.log(err)
            this.$buefy.toast.open({
              message: err.response.data,
              type: "is-danger",
            });
          });
        } else {
          //For creating a new grade
          this.createGrade({
            grade: this.grade,
            token: this.getTeacherToken,
          })
          .then(() => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: "Grade created successfully",
              type: "is-success",
            });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: err.response.data,
              type: "is-danger",
            });
          });
        }
      }
    },
  },
  async created() {
    if (this.grade_id) {
      this.isLoading = true;
      await this.loadGradeDetails({
        grade: this.grade_id,
        token: this.getTeacherToken,
      });

      for(let key in this.grade){
        this.grade[key] = this.fetchCurrentGrade[key]
      }
      // this.editfiles = this.fetchCurrentGrade.files.map((file_name) => {
      //   return {
      //     name: this.$common.fileBasename(file_name),
      //     is_deleted: false,
      //   }
      // })
      this.isLoading = false;
    }
  },
};
</script>
<style scoped>
</style>